import { DestroyRef, inject, Component, computed, input, effect } from '@angular/core';
import type { FormArray, FormControl, FormGroup } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDivider } from '@angular/material/divider';
import type { AbstractFileUploadService } from '@pct-ng/feature-file-upload-native';
import { isNil } from '@pct-ts/typeguard';
import { assertIsNotNil } from '@pct-ts/assert';
import { CoverImageComponent } from './cover-image.component';
import { TranslocoPipe } from '@jsverse/transloco';
import type { LanguageCode } from '@cappus/shared-common';
import { StringSlideToggleComponent } from '@pct-ng/form';
import type { ImageResizeMode } from './model/image-resize-mode';
import { IsNilPipe } from '@pct-ng/common/pipe';
import { MatTooltip } from '@angular/material/tooltip';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import type { Subscription } from 'rxjs';

type FormType = FormGroup<{
  translations: FormArray<FormGroup>;
  // isCoverImageUniform: FormControl<boolean>;
}>;

@Component({
  selector: 'cappus-cover-image-form-fragment',
  imports: [
    ReactiveFormsModule,
    MatDivider,
    CoverImageComponent,
    TranslocoPipe,
    StringSlideToggleComponent,
    IsNilPipe,
    MatTooltip,
  ],
  templateUrl: './cover-image-form-fragment.component.html',
})
export class CoverImageFormFragmentComponent<FORM extends FormType = FormType> {
  readonly #destroyRef = inject(DestroyRef);
  readonly i18nPrefix = input.required<string>();
  readonly coverImageControl = input.required<FormControl>();
  readonly resizeModeControl = input<FormControl | null>(null);
  readonly loading = input(false);
  readonly parentForm = input.required<FORM>();
  readonly selectedLanguage = input.required<LanguageCode>();
  readonly isSubtitleRequired = input.required<boolean>();
  readonly submitted = input.required<boolean>();
  readonly startedLanguages = input.required<LanguageCode[]>();
  protected readonly cover: ImageResizeMode = 'Cover';
  protected readonly contain: ImageResizeMode = 'Contain';

  /**
   * Any megengedett, mert a pontos tipust athozni nincs ertelme,
   * mivel direktben nem dolgozzunk a service altal letrehozott tipusokkal
   */
  readonly fileUploadService = input.required<AbstractFileUploadService<any>>();
  // protected readonly isCoverImageUniformControl = computed(() => {
  //   const control = this.parentForm().get('isCoverImageUniform');
  //   assertIsNotNil(control, 'isCoverImageUniform control not found in parent form');
  //   return control;
  // });
  protected readonly translationsFormArray = computed(() => {
    const control = this.parentForm().get('translations');
    assertIsNotNil(control, 'translations control not found in parent form');
    return control as FormArray<FormGroup>;
  });

  protected coverImageControlSubscription: Subscription | null = null;

  constructor() {
    effect(() => {
      const control = this.coverImageControl();
      if (!isNil(this.coverImageControlSubscription)) {
        this.coverImageControlSubscription.unsubscribe();
      }
      this.coverImageControlSubscription = control.valueChanges
        .pipe(takeUntilDestroyed(this.#destroyRef))
        .subscribe(() => {
          this.resizeModeControl()?.setValue(null);
        });
    });
  }

  //TODO: ez azért van kikommentezve, mert egyenlőre kivezetjük az egységes borítókép kapcsolót

  // ngOnInit(): void {
  //   this.isCoverImageUniformControl().valueChanges.subscribe(isUniform => {
  //     if (isUniform) {
  //       this.#copyCoverImageAndResizeModeToOthers();
  //     }
  //   });
  //
  //   const coverImageIdControls = this.translationsFormArray().controls.map(group =>
  //     group.controls.coverImageId.valueChanges.pipe(distinctUntilChanged()),
  //   );
  //
  //   merge(...coverImageIdControls)
  //     .pipe(filter(() => this.isCoverImageUniformControl().value))
  //     .subscribe(() => {
  //       this.#copyCoverImageAndResizeModeToOthers();
  //     });
  // }
  //
  // #copyCoverImageAndResizeModeToOthers(): void {
  //   const translationsArray = this.translationsFormArray();
  //   const selectedFormGroup = this.selectedLanguageFormGroup();
  //   const selectedFormGroupCoverImageId = selectedFormGroup.controls.coverImageId.value;
  //   let sourceFG: FormGroup<TranslationsFormType>;
  //   if (isNil(selectedFormGroupCoverImageId) || selectedFormGroupCoverImageId === '') {
  //     const firstFoundedImageFG = translationsArray.controls.find(
  //       group =>
  //         !isNil(group.controls.coverImageId.value) && group.controls.coverImageId.value !== '',
  //     );
  //     if (firstFoundedImageFG === undefined) {
  //       // no uploaded image
  //       return;
  //     }
  //     sourceFG = firstFoundedImageFG;
  //   } else {
  //     sourceFG = selectedFormGroup;
  //   }
  //   const { coverImageId, resizeMode } = sourceFG.controls;
  //
  //   translationsArray.controls.forEach(group => {
  //     if (group !== sourceFG) {
  //       group.patchValue({
  //         coverImageId: coverImageId.value,
  //         resizeMode: resizeMode.value,
  //       });
  //     }
  //   });
  // }
}

export type FormArrayFormGroupKeys<T> = T extends FormArray<FormGroup<infer U>> ? U : never;

// transform<T extends FormArray<FormGroup>, K extends keyof FormArrayFormGroupKeys<T>>(
//   formArray: T,
//   fields: K[],
// )
